export default {
    data() {
        return {
            plans: [],
        }
    },
    methods: {
        async loadPlans() {
            return await axios.get('/teacher/pagarme/plans')
                .then(response => {
                    return response.data.data.plans || []
                })
                .catch(error => {
                    return []
                })
        }
    }
}
